import React, { useState, useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Table,
  Space,
  Tag,
  Modal,
  Input,
  Typography,
  TimePicker,
} from "antd";
import {
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  ClearOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import "../LeaveAndPermissions/permission.css";
import { toast, ToastContainer } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbComponent from "../../components/BreadCrumb";
import api from "../../helpers";
import * as masterAction from "../../store/Masters/actions";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
import moment from "moment";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const BCrumb = [{ to: "/", title: "Home" }, { title: "LoginShift" }];

const LoginShift = () => {
  const [selectedRow, setSelectedRow] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();
  const [LoginShiftId, setLoginShiftId] = useState();
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [LoginShift, setLoginShift] = useState({
    LoginShiftName: "",
    description: "",
    startTime: "",
    endTime: "",
  });

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();

  //dropdown state from reducer
  const updateState = useSelector((state) => state.Masters);
  const { loginShiftList = [] } = updateState;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    specificDispatch(masterAction.loadLoginShifts({status:"BOTH"}));
  }, [specificDispatch]);

  // modal handling
  const showModalOpen = (type) => {
    setModalType(type);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalType("");
  };

  const onReset = () => {
    setResetLoading(true);
    setSearchInput("");
    setTimeout(() => {
      setLoginShift({
        LoginShiftName: "",
        description: "",
        startTime: "",
        endTime: "",
      });
      simpleValidator.current.hideMessages();
      forceUpdate(1);
      setResetLoading(false);
      setIsEdit(false);
      setLoginShiftId(null);
    }, 1000);
    dispatch(masterAction.loadLoginShifts({status:"BOTH"}));
    setDisabled(false);
  };

  const handleSubmit = () => {
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }

    setAddLoading(true);
    setDisabled(true);
    setTimeout(() => setDisabled(false), 4000);

    const payload = {
      shiftName: LoginShift.LoginShiftName,
      startTime: LoginShift.startTime?.format("HH:mm"),
      endTime: LoginShift.endTime?.format("HH:mm"),
      ...(LoginShift.description && {
        description: LoginShift.description,
      }),
      status: 1,
    };

    if (!isEdit) {
      api
        .post("/protected/addShift", payload)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            dispatch(masterAction.loadLoginShifts({status:"BOTH"}));
            toast.success("LoginShift added successfully", {
              containerId: "toast-1",
            });
            setLoginShift({ LoginShiftName: "", description: "" });
            simpleValidator.current.hideMessages();
            setAddLoading(false);
            forceUpdate(1);
          } else {
            toast.warning(res?.data?.msg || "");
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while adding the LoginShift";
          toast.error(errorMsg);
          setAddLoading(false);
        });
    } else {
      api
        .post(`/protected/updateshift/${LoginShiftId}`, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            dispatch(masterAction.loadLoginShifts({status:"BOTH"}));
            toast.success("LoginShift updated successfully", {
              containerId: "toast-1",
            });
            setLoginShift({ LoginShiftName: "", description: "" });
            setIsEdit(false);
            setLoginShiftId(null);
            simpleValidator.current.hideMessages();
            setAddLoading(false);
            forceUpdate(1);
          } else {
            toast.warning(response?.data?.msg || "");
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while updating the LoginShift";
          toast.error(errorMsg, { containerId: "toast-1" });
          setAddLoading(false);
        });
    }
  };

  const handleEdit = (LoginShiftData) => {
    setIsEdit(true);
    setLoginShift({
      LoginShiftName: LoginShiftData.LoginShiftName,
      startTime: LoginShiftData.startTime
        ? dayjs(LoginShiftData.startTime, "HH:mm")
        : null,
      endTime: LoginShiftData.endTime
        ? dayjs(LoginShiftData.endTime, "HH:mm")
        : null,
      description: LoginShiftData.description,
    });
  };

  //modal input handler
  const handleInput = (e) => {
    const { name, value } = e.target;

    setLoginShift((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    simpleValidator.current.hideMessageFor(name);
    forceUpdate(1);
  };

  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 5,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Action</span>,
      dataIndex: "action",
      width: 70,
      render: (_, record) => (
        <Space style={{ gap: "8px" }}>
          {/* Edit Button */}
          <Button
            style={{
              background: "#34c38f",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              handleEdit(record);
              setLoginShiftId(record._id);
            }}
          >
            <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Delete Button */}
          <Button
            style={{
              background: "#f46a6a",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              showModalOpen("delete");
              setLoginShiftId(record._id); // single delete
              setSelectedRow([]); // make sure no bulk delete happens
            }}
          >
            <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>
        </Space>
      ),
    },
    {
      title: <span className="poppins-txt">LoginShift</span>,
      dataIndex: "LoginShiftName",
      width: 130,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Start Time</span>,
      dataIndex: "startTime",
      width: 130,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">End Time</span>,
      dataIndex: "endTime",
      width: 130,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Description</span>,
      dataIndex: "description",
      width: 130,
      className: "poppins-txt-lg",
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Status
        </span>
      ),
      dataIndex: "status",
      width: 100,
      render: (status) => {
        const isActive = status?.toLowerCase() === "active";
        return (
          <Tag
            style={{
              backgroundColor: isActive ? "#e6f4d7" : "#fae1e1",
              color: isActive ? "#34c38f" : "#f46a6a",
              fontWeight: 500,
              width: 60,
              height: 20,
              paddingTop: "2px",
              fontSize: "11px",
              textAlign: "center",
              lineHeight: "16px",
              borderRadius: 4,
              border: "none",
              fontFamily: "Poppins",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
  ];

  const handleTimeChange = (name, value) => {
    setLoginShift((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
      status:"BOTH"
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(masterAction.loadLoginShifts(payload));
  };

  //download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);

    const searchFilter = {};

    try {
      const res = await api.post("/protected/getallshift", searchFilter);
      const LoginShift = res.data?.result || [];

      const mappedData = LoginShift.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        LoginShiftName: data.shiftName || "--",
        startTime: moment(data.startTime).format("HH:mm") || "--",
        endTime: moment(data.endTime).format("HH:mm") || "--",
        description: data.description || "--",
        status: data.status === 1 ? "Active" : "Inactive",
      }));

      // Only include fields for CSV that you want:
      const headers = ["S.No", "LoginShift Name", "Description", "Status"];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.LoginShiftName,
        item.description,
        item.status,
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "LoginShift-details.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };

  //delete
  const handleUpdateStatus = (statusType) => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);

    const statusMap = {
      delete: 3,
      active: 1,
      inactive: 2,
    };

    const toastMessage = {
      delete: "LoginShift deleted successfully",
      active: "LoginShift activated successfully",
      inactive: "LoginShift deactivated successfully",
    };

    const statusValue = statusMap[statusType];
    if (!statusValue) return;
    const id = !isEmpty(selectedRow) ? selectedRow : [LoginShiftId];
    const payload = {
      id: id, // use selectedRow instead of hardcoded ID
      status: statusValue,
    };
    api
      .post(`/protected/deleteShift`, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          specificDispatch(masterAction.loadLoginShifts({status:"BOTH"}));
          toast.success(toastMessage[statusType], { containerId: "toast-1" });
          setSelectedRow([]);
          setLoginShiftId(null);
          handleModalClose();
        } else {
          toast.warning(response?.data?.msg || "");
        }
        return response.data;
      })
      .catch((err) => {
         setSelectedRow([]);
          handleModalClose();
        const errorMsg =
       err?.response?.data?.error||err?.response?.data?.message ||
          "An error occurred while deleting the LoginShift details";
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };

  const tableData = !isEmpty(loginShiftList)
    ? loginShiftList.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        LoginShiftName: data.shiftName || "--",
        startTime: data.startTime
          ? dayjs(data.startTime)
              .tz("America/New_York")
              .format("h:mmA")
              .toLowerCase()
          : "--",
        endTime: data.endTime
          ? dayjs(data.endTime)
              .tz("America/New_York")
              .format("h:mmA")
              .toLowerCase()
          : "--",
        description: data.description || "--",
        status: data.status === 1 ? "Active" : "Inactive",
      }))
    : [];

  return (
    <>
      <div className="pl-5">
        <MetaTags>
          <title>LoginShift | Mequals</title>
        </MetaTags>
      </div>
      <Row>
        <BreadcrumbComponent title="LoginShift" items={BCrumb} />
      </Row>

      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px",
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Typography className="poppins-txt">
              LoginShift Name
              <span style={{ color: "red", marginLeft: "2px" }}>*</span>
            </Typography>
            <Input
              placeholder="Enter LoginShift Name"
              allowClear
              style={{ width: "100%", fontFamily: "Poppins", marginTop: "5px" }}
              name="LoginShiftName"
              type="text"
              className="custom-select"
              value={LoginShift.LoginShiftName}
              onChange={(e) => handleInput(e)}
              autoComplete="off"
            />
            <span
              style={{
                color: "#ef3022",
                fontSize: "11px",
                marginTop: "8px",
                fontFamily: "poppins",
                display: "block",
              }}
            >
              {simpleValidator.current.message(
                "LoginShiftName",
                LoginShift.LoginShiftName,
                "required"
              )}
            </span>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Typography className="poppins-txt">
              Start Time
              <span style={{ color: "red", marginLeft: "2px" }}>*</span>
            </Typography>
            <TimePicker
              showSecond={false}
              minuteStep={15}
              value={LoginShift.startTime}
              onChange={(time) => handleTimeChange("startTime", time)}
              use12Hours={false}
              format="HH:mm"
              style={{ width: "100%", marginTop: "5px" }}
              className="custom-select-time w-100"
              placeholder="Select from time"
            />
            <span
              style={{
                color: "#ef3022",
                fontSize: "11px",
                marginTop: "8px",
                fontFamily: "poppins",
                display: "block",
              }}
            >
              {simpleValidator.current.message(
                "startTime",
                LoginShift.startTime,
                "required"
              )}
            </span>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Typography className="poppins-txt">
              End Time
              <span style={{ color: "red", marginLeft: "2px" }}>*</span>
            </Typography>
            <TimePicker
              showSecond={false}
              minuteStep={15}
              value={LoginShift.endTime}
              onChange={(time) => handleTimeChange("endTime", time)}
              use12Hours={false}
              format="HH:mm"
              style={{ width: "100%", marginTop: "5px" }}
              className="custom-select-time w-100"
              placeholder="Select from time"
            />
            <span
              style={{
                color: "#ef3022",
                fontSize: "11px",
                marginTop: "8px",
                fontFamily: "poppins",
                display: "block",
              }}
            >
              {simpleValidator.current.message(
                "endTime",
                LoginShift.endTime,
                "required"
              )}
            </span>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Typography className="poppins-txt">Description</Typography>
            <Input
              placeholder="Enter Description"
              allowClear
              style={{ width: "100%", fontFamily: "Poppins", marginTop: "5px" }}
              name="description"
              className="custom-select"
              type="text"
              value={LoginShift.description}
              onChange={(e) => handleInput(e)}
              autoComplete="off"
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div
              className="mt-1"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                className="custom-btn"
                size="middle"
                type="primary"
                style={{ marginRight: "12px" }}
                onClick={handleSubmit}
                disabled={disabled}
                loading={addLoading}
              >
                {isEdit ? (
                  "Update"
                ) : (
                  <span>
                    <PlusOutlined></PlusOutlined>Add
                  </span>
                )}
              </Button>
              <Button
                className="custom-btn"
                style={{ background: "#FCE05A", color: "white" }}
                size="middle"
                htmlType="submit"
                onClick={onReset}
                loading={resetLoading}
              >
                <ClearOutlined />
                Clear
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px",
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Input
              placeholder="Search..."
              allowClear
              style={{ width: 250, fontFamily: "Poppins" }}
              name="searchInput"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              type="text"
              autoComplete="off"
            />

            <Button
              icon={<SearchOutlined />}
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleSearch}
            />
          </Col>

          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={exportToCsv}
              loading={downloadLoader}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          loading={searchLoading}
          dataSource={tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            // make sure you provide total count from API
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          scroll={{
            x: 765,
          }}
          rowSelection={{
            selectedRowKeys: selectedRow,
            preserveSelectedRowKeys: true,
            onSelectAll: (selected, selectedRows) => {
              const newSelecteds = selected
                ? selectedRows.map((n) => n._id)
                : [];
              setSelectedRow(newSelecteds);
            },
            onSelect: (record, selected) => {
              let newSelecteds = selected
                ? [...selectedRow, record._id]
                : selectedRow.filter((id) => id !== record._id);
              setSelectedRow(newSelecteds);
            },
          }}
        />

        <Space size={4}>
          <Button
            style={{
              marginTop: "20px",
              marginRight: "12px",
              background: "#f46a6a",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("delete")}
          >
            Delete
          </Button>

          <Button
            style={{
              marginTop: "20px",
              background: "#34c38f",
              marginRight: "12px",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("active")}
          >
            Active
          </Button>

          <Button
            style={{
              marginTop: "20px",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("inactive")}
          >
            Inactive
          </Button>
        </Space>

        <Modal
          open={isModalVisible}
          onCancel={handleModalClose}
          title={"Confirmation"}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          centered
          width={450}
          footer={null} // Remove the default footer
          // style={{ padding: 0, marginLeft: "600px" }} // Remove padding from modal
        >
          <div className="custom-modal-content">
            <p>Are you sure you want to {modalType} this LoginShift?</p>
          </div>

          {/* Custom footer with cancel and confirm buttons */}
          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              onClick={handleModalClose}
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
            >
              Close
            </Button>
            <Button
              className="custom-btn"
              disabled={disabled}
              // onClick={handleModalClose}
              onClick={() => handleUpdateStatus(modalType)}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>
      </div>
      <ToastContainer
        containerId="toast-1"
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default LoginShift;
